module.exports = __webpack_public_path__ + "static/item--sofa-2@3x.0519931e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--sofa-2@3x.png
// module id = 664
// module chunks = 126511778744290